import React from 'react';
import PropTypes from 'prop-types';
import utils from "@utils";
import OfficerNonRKPayInvoiceItemForm from './components/OfficerNonRKPayInvoiceItemForm';
import OfficerNonRKPayInvoiceItemView from './components/OfficerNonRKPayInvoiceItemView'

const OfficerNonRKPayInvoiceItems = ({
	user,
	officer,
	lineItems,
	nonRKPayInvoiceDetailHook,
	invoiceNotEditable,
	getDisputeReasonsByJobId
}) => {
	const { lang } = global;

	const { getOfficerTotalAcrossJobs } = nonRKPayInvoiceDetailHook;

	return (
		<div
			className="row officer-jobs"
			key={`ov-${officer.OfficerId || "e"}_${officer.OfficerName.replace(/\s/g, "")}`}
		>
			<div className="col-xs-6 col-md-3 officer-header">
				<strong className="card-only">{lang.t("Officer")}: </strong>
				<span>{officer.OfficerName}</span>
			</div>
			<div className="col-xs-6 col-md-1 col-md-offset-8 text-right print-amount">
				<strong>
					{utils.currencyFormatter(
						getOfficerTotalAcrossJobs(officer),
					)}
				</strong>
			</div>
			{lineItems && lineItems.map(item => {
				if (item.OfficerName === officer.OfficerName &&
					item.OfficerId === officer.OfficerId) {

					if (invoiceNotEditable || item.Finalized) {
						return (
							<OfficerNonRKPayInvoiceItemView
								key={`officer-item-${item.JobAssignmentId}`}
								user={user}
								item={item}
							/>
						)
					}

					return (
						<OfficerNonRKPayInvoiceItemForm
							key={`officer-item-${item.JobAssignmentId}`}
							user={user}
							item={item}
							nonRKPayInvoiceDetailHook={nonRKPayInvoiceDetailHook}
							getDisputeReasonsByJobId={getDisputeReasonsByJobId}
						/>
					)

				}
				return null;
			})}
		</div>
	);
};

OfficerNonRKPayInvoiceItems.propTypes = {
	user: PropTypes.object,
	officer: PropTypes.object,
	lineItems: PropTypes.array,
	nonRKPayInvoiceDetailHook: PropTypes.object.isRequired,
	invoiceNotEditable: PropTypes.bool,
	getDisputeReasonsByJobId: PropTypes.func,
};

OfficerNonRKPayInvoiceItems.defaultProps = {
	user: {},
	officer: {},
	lineItems: [],
	invoiceNotEditable: false,
	getDisputeReasonsByJobId: () => [],
};

export default OfficerNonRKPayInvoiceItems;
